import { SearchModes } from '@/domainLogic/index.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { createQueryString } from '@/utils/queryUtils.ts';
import { getSearchParam } from '@/app/common/urlParametersUtils.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { createDatesParams } from '@/app/common/memsearch/getSearchParams.ts';
import getSearchParams from '../../../../common/getSearchParams';
import type { CuriosityParams } from '../../../../Curiosity';
import redirectEvent from '../../../../Curiosity/redirectEvent';
import type { Localization } from '../../../../common/Localization';
import type { DealCard } from '../../../../utils/buildDealCards/dealCardTypes';

type SDPRedirectEventProps = {
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  dealCard: DealCard;
  searchId: string;
  currency: string;
};

export const SDPRedirectEvent = ({
  commonData,
  localization,
  curiosityParams,
  dealCard,
  searchId,
  currency,
}: SDPRedirectEventProps) => {
  /* CURIOSITY */
  if (curiosityParams && commonData.userUid && commonData.sessionId) {
    const {
      accommodation: { hotelId },
      rate: {
        price: {
          price,
          total: { price: totalPrice },
        },
      },
      dates: { dateFrom: dateFromProduct, dateTo: dateToProduct, checkin, checkout, nights },
      geo: { origin, originAp, destinationAp, internalIdCity },
    } = dealCard.product;
    const searchParams = getSearchParams();
    const adddays = getSearchParam(searchParams, URLParameters.ADD_DAYS);
    const dateFrom = searchParams[URLParameters.DATE_FROM];
    const dateTo = searchParams[URLParameters.DATE_TO];
    const datesParams = createDatesParams(adddays ? parseInt(adddays, 10) : 0, dateFrom, dateTo);
    const { datefrom: searchDateFrom, dateto: searchDateTo } = datesParams;
    const paramsToQueryString = createQueryString({
      ...searchParams,
      [URLParameters.DATE_FROM]: searchDateFrom,
      [URLParameters.DATE_TO]: searchDateTo,
    });

    const DPParams =
      searchParams.searchMode === SearchModes.DP
        ? {
            offer_origin: origin,
            offer_origin_airport: originAp,
            offer_flight_class: 'E',
          }
        : {};

    const redirectParams = {
      ...DPParams,
      redirect_type: 'details_1sdp',
      trace_id: '00000000-0000-0000-0000-000000000000',
      offer_destination_airport: destinationAp,
      offer_destination_internal_id_city: internalIdCity,
      offer_internal_id_hotel: hotelId,
      offer_departure_date: dateFromProduct,
      offer_return_date: dateToProduct,
      offer_checkin_date: checkin,
      offer_checkout_date: checkout,
      offer_nights: nights,
      offer_currency: currency,
      offer_price_displayed: price,
      offer_price_total: totalPrice,
    };

    redirectEvent({
      url: `/?${paramsToQueryString}`,
      searchMode: searchParams.searchMode,
      offset: 0,
      group: 2,
      searchId,
      redirectParams,
      commonData,
      localization,
      curiosityParams,
    });
  }

  /* CURIOSITY */
};
